import { z } from 'zod';

import { GroupNodeSchema } from './groupNode.js';
import { StickyNoteNodeSchema } from './stickyNotes.js';

export const FlowDecorationNodeSchema = z.discriminatedUnion('decorationType', [
  StickyNoteNodeSchema,
  GroupNodeSchema,
]);
export type FlowDecorationNode = z.infer<typeof FlowDecorationNodeSchema>;

export const FlowDecorationDataSchema = z.object({
  nodes: FlowDecorationNodeSchema.array(),
});
export type FlowDecorationData = z.infer<typeof FlowDecorationDataSchema>;
